import React, { Component } from "react";
import config from "lib/fr-config";
import { getDeviceType } from "lib/deviceInfo";

const desktopCss = config.css.desktop;
const mobileCss = config.css.mobile;

const cssXL = {
  root: {
    paddingTop:
      desktopCss.headerBarHeightPX +
      desktopCss.paddingBetweenHeaderbarAndFirstContent,
    paddingLeft: desktopCss.sidePadding,
    paddingRight: desktopCss.sidePadding,
    maxWidth: desktopCss.maximumWidth,
    minWidth: desktopCss.minimumWidth,
    margin: "auto"
  }
};
const cssXS = {
  root: {
    paddingTop: mobileCss.paddingBetweenHeaderbarAndFirstContent,
    paddingLeft: mobileCss.sidePadding,
    paddingRight: mobileCss.sidePadding,
    marginBottom: `calc(env(safe-area-inset-bottom) + ${mobileCss.headerBarHeightPX}px)`
  }
};

class BorderSpaceView extends Component {
  render() {
    const { children } = this.props;
    const css = getDeviceType() === "mobile" ? cssXS : cssXL;

    return <div style={css.root}>{children}</div>;
  }
}

export default BorderSpaceView;
